<template>
<div class="accordion-select" @click="handleClick">
    <v-select :options="columns" v-model="value_obj"
        :searchable="true" class="searchable-select column-display category"
        :selectable="(option) => option.text != ''"
        label="text" @search="fetchOptions"
        ref="selectWithListHeader"
        @update:modelValue="emitInput()"
        :filterable="false"
        data-bs-toggle="tooltip"
        :data-bs-original-title="getColumnTitle(value_obj)"
        @open="handleColumnDisplayOpen"
        :disabled="!if_allow_edit">
        <template #list-header="{ search }">
            <li class="list-header border-bottom border-primary border-1" @click="emitListHeaderAction(search)" @mouseover="focusOnListHeader()">
                <a class="btn btn-link">{{ list_header_text }}</a>
            </li>
        </template>
        <template #selected-option="{ text, category, subcategory }">
            <span :option-selected="text" :title="getColumnTitle({category, subcategory, text})">
                {{(category != null && category != "" && category.toLowerCase() != "list-header" ? category + ": " : "")}}{{subcategory != null && subcategory != "" ? subcategory + " › " : ""}}{{text}}
            </span>
        </template>

        <template #open-indicator="{ attributes }">
          <span v-bind="attributes" style="width: 12px; line-height: 8px;"><svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg></span>
        </template>

        <template #option="{ text, category, subcategory, extra }">
          <div v-if="text == '' && !subcategory && category.toLowerCase() != 'list-header'" :data-category="category" class="category-header"
            @click="expandCategory(category, null)"
            @mouseover="handleHover($event)"
            :data-isexpanded="false">
            {{ category }} <i class="fas fa-caret-right"></i>
          </div>
          <div v-else-if="text == '' && subcategory"
            :data-subcategory="category"
            :data-subcategory-name="subcategory"
            class="subcategory-header"
            @click="expandSubcategory(category, subcategory, null)"
            @mouseover="handleHover($event)"
            :data-isexpanded="false"
            v-show="isSubcategoryVisible(category, subcategory)">
            {{ subcategory }} <i class="fas fa-caret-right"></i>
          </div>
          <div v-else-if="text != list_header_text" class="suboption" :data-subcategory="category" :data-subcategory-name="subcategory"
            :class="shouldShowOption(category, subcategory)"
            @mouseover="handleHover($event)">
            {{getDisplayText(text)}} <span v-if="extra != null" v-html="extra"></span>
          </div>
          <div v-else class="suboption d-none" :data-subcategory="category" :data-subcategory-name="subcategory"></div>
        </template>
        <template #no-options="{ search, searching, loading }">
            <div class="suboption show" v-if="is_loading">
                <div class="d-inline-block spinner-border spinner-border-sm ms-2" role="status"> <span class="visually-hidden">Loading...</span></div>  Loading columns
            </div>
            <div class="suboption show" v-else>
                <em>No results found</em>
            </div>
        </template>
    </v-select>
    <input type="hidden" :name="name" :value="(value_obj == null ? null : value_obj.value)" />
</div>
</template>

<script>
    import vSelect from "vue3-select";
    import Multiselect from '@vueform/multiselect'

    export default {
        props: {
            modelValue: {
              default: '',
            },
            list_header_text:{
                type: String,
                default: '',
            },
            options: {
                type: Array,
                default: () => []
            },
            name: {
              type: String,
              default: 'vue-select',
            },
            if_allow_edit: {
                type: Boolean,
                default: true
            }
        },
        components: {
            vSelect,
            Multiselect
        },
        data() {
            return {
                value_obj: null,
                columns: [],
                orig_columns: [],
                expanded_categories: [],
                expanded_subcategories: [],
                is_loading: false
            };
        },
        beforeMount() {
            this.resetValueObject();
        },
        watch:{
            options: {
                handler(newValue) {
                    this.columns =[];
                    for(var i = 0; i < this.options.length; i++) {
                        if(!this.options[i] || !this.options[i].value){
                            continue;
                        }
                        //Don't include any columns that start with _ but do include if it starts with __
                        if(this.options[i] && this.options[i].value && typeof this.options[i].value === 'string') {
                            const value = String(this.options[i].value);
                            if((value.indexOf("_") == 0 && value.indexOf("__") != 0) || 
                               (value.indexOf("._") >= 0 && value.indexOf(".__") == -1)) {
                                continue;
                            }
                        }
                        this.columns.push(this.options[i]);
                    }
                    this.addHeaders();
                    this.orig_columns = JSON.parse(JSON.stringify(this.columns))

                    if(this.modelValue != null) {
                        // Handle both string and object modelValue
                        const searchValue = (typeof this.modelValue === 'object' && this.modelValue.value !== undefined) 
                            ? this.modelValue.value 
                            : this.modelValue;
                        this.value_obj = this.options.find(option => option.value == searchValue);
                    }
                }
            },
            modelValue: {
                handler(newValue) {
                    this.$emit('change');
                    this.resetValueObject();
                }
            },
            value_obj: {
                handler(newVal) {
                    // Reinitialize tooltips when value changes
                    this.$nextTick(() => {
                        this.initTooltips();
                    });
                },
                deep: true
            }
        },
        mounted() {
            this.columns =[];
            if(this.options){
                for(var i = 0; i < this.options.length; i++) {
                    //Don't include any columns that start with _
                    if(this.options[i] && this.options[i].value && typeof this.options[i].value === 'string') {
                        const value = String(this.options[i].value);
                        if((value.indexOf("_") == 0 && value.indexOf("__") != 0) || 
                           (value.indexOf("._") >= 0 && value.indexOf(".__") == -1)) {
                            continue;
                        }
                    }
                    this.columns.push(this.options[i]);
                }
            }

            this.addHeaders();
            this.orig_columns = JSON.parse(JSON.stringify(this.columns));

            // Ensure value_obj is set correctly
            this.$nextTick(() => {
                this.resetValueObject();
                this.initTooltips();
            });
        },
        updated() {
            this.initTooltips();
        },
        methods: {
            handleColumnDisplayOpen() {
                // Reset expanded states
                this.expanded_categories = [];
                this.expanded_subcategories = [];

                // First handle the selected column's category/subcategory
                if (this.value_obj && this.value_obj.category) {
                    // Don't expand the selected category initially
                    this.expanded_categories = [];
                    if (this.value_obj.subcategory) {
                        this.expanded_subcategories = [];
                    }
                }

                // Ensure all categories and subcategories are collapsed
                this.$nextTick(() => {
                    // Find all category headers and collapse them
                    const categoryHeaders = document.querySelectorAll('.category-header');
                    categoryHeaders.forEach(header => {
                        const category = header.dataset.category;
                        if (category) {
                            const icon = header.querySelector('.fa-caret-right, .fa-caret-down');
                            if (icon) {
                                icon.classList.add('fa-caret-right');
                                icon.classList.remove('fa-caret-down');
                            }
                            header.dataset.isexpanded = "false";
                        }
                    });

                    // Find all subcategory headers and collapse them
                    const subcategoryHeaders = document.querySelectorAll('.subcategory-header');
                    subcategoryHeaders.forEach(header => {
                        const icon = header.querySelector('.fa-caret-right, .fa-caret-down');
                        if (icon) {
                            icon.classList.add('fa-caret-right');
                            icon.classList.remove('fa-caret-down');
                        }
                        header.dataset.isexpanded = "false";
                    });
                });
            },
            getColumnTitle(col) {
                if(col == null || col.value == null)
                    return '';
                
                const { category, subcategory, text } = col;
                let title = '';
                
                if(category != null && category != "") {
                    title += category + ": ";
                }
                if(subcategory != null && subcategory != "") {
                    title += subcategory + " › ";
                }
                title += text || '';
                
                return title;
            },
            resetValueObject(){
                if(this.modelValue != null) {
                    // Extract the actual value to search for (handle both string and object modelValue)
                    const searchValue = (typeof this.modelValue === 'object' && this.modelValue.value !== undefined) 
                        ? this.modelValue.value 
                        : this.modelValue;
                    
                    // Try to find the option by value
                    const foundOption = this.options.find(option => option.value === searchValue ||
                        (option.value === -1 && searchValue === -1));

                    if (foundOption) {
                        this.value_obj = foundOption;
                    } else if (typeof this.modelValue === 'object' && this.modelValue.value !== undefined) {
                        // If value is an object with a value property, try to find it in options first
                        const objFoundOption = this.options.find(option => option.value === this.modelValue.value);
                        if (objFoundOption) {
                            this.value_obj = objFoundOption;
                        } else {
                            // If not found in options, use the object directly
                            this.value_obj = this.modelValue;
                        }
                    } else {
                        // Default to empty
                        this.value_obj = {
                            value: '',
                            category: '',
                            subcategory: '',
                            text: ""
                        };
                    }
                } else {
                    // Default to empty
                    this.value_obj = {
                        value: '',
                        category: '',
                        subcategory: '',
                        text: ""
                    };
                }
            },
            handleClick() {
              this.$emit('editing');
            },
            focusOnListHeader(){
                // when hovering on list header, remove highlight on suboptions
                const highlightedSuboption = document.querySelector('.vs__dropdown-option--highlight');
                if(highlightedSuboption){
                    highlightedSuboption.classList.remove("vs__dropdown-option--highlight");
                }
            },
            emitInput() {
                if(this.value_obj == null)
                    this.$emit('update:modelValue', null);
                else
                    this.$emit('update:modelValue', this.value_obj.value);
            },
            emitListHeaderAction(search){
                const searchEl = this.$refs.selectWithListHeader.searchEl;
                if (searchEl) {
                    searchEl.blur();
                }
                this.$emit('listHeaderAction', search);
            },
            addHeaders() {
                var current_category = null;
                var current_subcategory = null;

                // Sort columns to ensure proper nesting
                this.columns.sort((a, b) => {
                    // Convert values to strings for comparison
                    const aValue = String(a.value);
                    const bValue = String(b.value);
                    
                    // First sort by category
                    if(aValue.indexOf(".") == -1 && bValue.indexOf(".") != -1)
                        return -1;
                    else if(aValue.indexOf(".") != -1 && bValue.indexOf(".") == -1)
                        return 1;
                    
                    // If same category, sort by subcategory presence
                    if(aValue.indexOf(".") != -1 && bValue.indexOf(".") != -1) {
                        const aParts = aValue.split(".");
                        const bParts = bValue.split(".");
                        
                        // If same category
                        if(aParts[0] === bParts[0]) {
                            // If one has subcategory and other doesn't, put the one without subcategory first
                            if(aParts.length === 2 && bParts.length > 2) return -1;
                            if(aParts.length > 2 && bParts.length === 2) return 1;
                            
                            // If both have subcategories, sort by subcategory
                            if(aParts.length > 2 && bParts.length > 2) {
                                return aParts[1].localeCompare(bParts[1]);
                            }
                        }
                        return aParts[0].localeCompare(bParts[0]);
                    }
                    
                    return aValue.localeCompare(bValue);
                });

                for(let i = 0; i < this.columns.length; i++) {
                    let col = this.columns[i];
                    let category = null;
                    let subcategory = null;
                    let text = col.text;

                    // Convert value to string for processing
                    const colValue = String(col.value);

                    if (col.category && col.category.trim() != '') {
                        // Use explicit category value first
                        category = this.propercase(col.category);
                        text = col.text;

                        // Derive subcategory from either explicit property or dot-notation in value
                        if (col.subcategory && col.subcategory.trim() !== '') {
                            subcategory = this.propercase(col.subcategory);
                        } else if (colValue.indexOf(".") !== -1) {
                            const parts = colValue.split(".");
                            if (parts.length > 2) {
                                subcategory = this.propercase(parts[1]);
                            }
                        } else {
                            subcategory = null;
                        }

                        // Add category divider if category changes
                        if(category != current_category) {
                            this.columns.splice(i, 0, {
                                value: "DIVIDER-"+ category,
                                category: category,
                                text: "",
                                subcategory: null
                            });
                            current_subcategory = null; // Reset subcategory when category changes
                            i++; // Increment i since we added an element
                        }

                        // Add subcategory divider if subcategory exists and changes
                        if(subcategory && subcategory != current_subcategory) {
                            this.columns.splice(i, 0, {
                                value: "DIVIDER-"+ category + "-" + subcategory,
                                category: category,
                                subcategory: subcategory,
                                text: ""
                            });
                            i++; // Increment i since we added an element
                        }
                    } else if(colValue.indexOf(".") != -1) {
                        let parts = colValue.split(".");
                        category = this.propercase(parts[0]);
                        
                        if(parts.length > 2) {
                            subcategory = this.propercase(parts[1]);
                            // For 3+ levels, join remaining parts with ›
                            text = this.propercase(parts.slice(2).join(' › '));
                        } else {
                            text = this.propercase(parts[1]);
                        }

                        // Add category divider if category changes
                        if(category != current_category) {
                            this.columns.splice(i, 0, {
                                value: "DIVIDER-"+ category,
                                category: category,
                                text: "",
                                subcategory: null
                            });
                            current_subcategory = null; // Reset subcategory when category changes
                            i++; // Increment i since we added an element
                        }

                        // Add subcategory divider if subcategory changes
                        if(subcategory && subcategory != current_subcategory) {
                            this.columns.splice(i, 0, {
                                value: "DIVIDER-"+ category + "-" + subcategory,
                                category: category,
                                subcategory: subcategory,
                                text: ""
                            });
                            i++; // Increment i since we added an element
                        }
                    }

                    current_category = category;
                    current_subcategory = subcategory;

                    // Update the column with the processed values
                    this.columns[i] = {
                        ...col,
                        category: category,
                        subcategory: subcategory,
                        text: text
                    };
                }
            },
            expandCategory(cat, expand) {
                if (!cat) return false;
                
                // Update state arrays first for immediate reactivity
                const isExpanded = this.expanded_categories.includes(cat);
                const shouldExpand = expand === true || !isExpanded;
                
                if (shouldExpand && !this.expanded_categories.includes(cat)) {
                    this.expanded_categories.push(cat);
                } else if (!shouldExpand) {
                    this.expanded_categories = this.expanded_categories.filter(c => c !== cat);
                    // Remove all subcategories of this category
                    this.expanded_subcategories = this.expanded_subcategories.filter(sc => !sc.startsWith(cat + '-'));
                }

                // Update DOM after Vue's reactive cycle
                this.$nextTick(() => {
                    const categoryHeader = document.querySelector(`div[data-category='${cat}']`);
                    if (!categoryHeader) return false;

                    // Update category header
                    const categoryIcon = categoryHeader.querySelector('.fa-caret-right, .fa-caret-down');
                    if (categoryIcon) {
                        categoryIcon.classList.toggle('fa-caret-right', !shouldExpand);
                        categoryIcon.classList.toggle('fa-caret-down', shouldExpand);
                    }
                    categoryHeader.dataset.isexpanded = shouldExpand;

                    // Find and update all related subcategory headers
                    const subcategoryHeaders = document.querySelectorAll(`div[data-subcategory='${cat}'].subcategory-header`);
                    subcategoryHeaders.forEach(header => {
                        header.style.display = shouldExpand ? "block" : "none";
                        if (!shouldExpand) {
                            header.dataset.isexpanded = "false";
                            const subcategoryIcon = header.querySelector('.fa-caret-right, .fa-caret-down');
                            if (subcategoryIcon) {
                                subcategoryIcon.classList.add('fa-caret-right');
                                subcategoryIcon.classList.remove('fa-caret-down');
                            }
                        }
                    });
                });

                return false;
            },
            expandSubcategory(cat, subcat, expand) {
                if (!cat || !subcat) return false;

                const subcategoryKey = `${cat}-${subcat}`;
                const isExpanded = this.expanded_subcategories.includes(subcategoryKey);
                const shouldExpand = expand === true || !isExpanded;

                // Update state array first for immediate reactivity
                if (shouldExpand && !this.expanded_subcategories.includes(subcategoryKey)) {
                    this.expanded_subcategories.push(subcategoryKey);
                } else if (!shouldExpand) {
                    this.expanded_subcategories = this.expanded_subcategories.filter(sc => sc !== subcategoryKey);
                }

                // Update DOM after Vue's reactive cycle
                this.$nextTick(() => {
                    const header = document.querySelector(`div[data-subcategory='${cat}'][data-subcategory-name='${subcat}']`);
                    if (!header) return false;

                    // Update header
                    const icon = header.querySelector('.fa-caret-right, .fa-caret-down');
                    if (icon) {
                        icon.classList.toggle('fa-caret-right', !shouldExpand);
                        icon.classList.toggle('fa-caret-down', shouldExpand);
                    }
                    header.dataset.isexpanded = shouldExpand;

                    // Find and update all options under this subcategory
                    const options = document.querySelectorAll(`div[data-subcategory='${cat}'][data-subcategory-name='${subcat}'] + div.suboption`);
                    options.forEach(option => {
                        option.style.display = shouldExpand ? "block" : "none";
                    });
                });

                return false;
            },
            shouldShowOption(category, subcategory) {
                let classes = [];
                
                if (!category) {
                    classes.push('show');
                } else {
                    classes.push('category-option');
                    const categoryExpanded = this.expanded_categories.includes(category);
                    if (!categoryExpanded) return classes.join(' ');
                    
                    if (!subcategory) {
                        classes.push('show');
                    } else {
                        classes.push('subcategory-option');
                        const subcategoryKey = `${category}-${subcategory}`;
                        if (this.expanded_subcategories.includes(subcategoryKey)) {
                            classes.push('show');
                        }
                    }
                }
                
                return classes.join(' ');
            },
            handleHover(event) {
                // Remove selected and highlight classes from all options
                const allOptions = document.querySelectorAll('.vs__dropdown-option');
                allOptions.forEach(option => {
                    option.classList.remove('vs__dropdown-option--selected', 'vs__dropdown-option--highlight');
                });
            },
            fetchOptions(search, loading) {
                //Reset the array
                this.columns = JSON.parse(JSON.stringify(this.orig_columns));

                if(search == "") {
                    // Reset expanded states when no search
                    this.expanded_categories = [];
                    this.expanded_subcategories = [];
                    return;
                }

                //Look at each column
                for(var i = this.columns.length-1; i >= 0 ; i--) {
                    const item = this.columns[i];
                    
                    // Check if search matches text, category, or subcategory
                    const searchLower = search.toLowerCase();
                    const textMatch = item.text && item.text.toLowerCase().indexOf(searchLower) !== -1;
                    const categoryMatch = item.category && item.category.toLowerCase().indexOf(searchLower) !== -1;
                    const subcategoryMatch = item.subcategory && item.subcategory.toLowerCase().indexOf(searchLower) !== -1;
                    
                    // Keep item if it matches search in any field, or if it's a category/subcategory divider
                    if (!textMatch && !categoryMatch && !subcategoryMatch && item.text !== "") {
                        this.columns.splice(i, 1);
                    }
                }

                //Get the remaining categories and subcategories
                var cats = [];
                var subcats = new Map(); // Map to track subcategories and their matching options
                
                for(var i = 0; i < this.columns.length; i++) {
                    const item = this.columns[i];
                    if(item.category != null && item.text != "") {
                        if(!cats.includes(item.category)) {
                            cats.push(item.category);
                        }
                        
                        // Track subcategories that have matching options
                        if(item.subcategory) {
                            const key = `${item.category}-${item.subcategory}`;
                            if(!subcats.has(key)) {
                                subcats.set(key, false);
                            }
                            subcats.set(key, true);
                        }
                    }
                }

                //Remove subcategory headers that have no matching options
                for(var i = this.columns.length-1; i >= 0 ; i--) {
                    const item = this.columns[i];
                    if(item.text == "" && item.subcategory) {
                        const key = `${item.category}-${item.subcategory}`;
                        if(!subcats.get(key)) {
                            this.columns.splice(i, 1);
                        }
                    }
                }

                //Remove category headers that have no matching options
                for(var i = this.columns.length-1; i >= 0 ; i--) {
                    const item = this.columns[i];
                    if(item.text == "" && item.category != null && !cats.includes(item.category)) {
                        this.columns.splice(i, 1);
                    }
                }

                //Expand the categories and subcategories
                for(var i = 0; i < cats.length; i++) {
                    this.expandCategory(cats[i], true);
                    // Find and expand all subcategories for this category
                    subcats.forEach((hasMatches, key) => {
                        const [category, subcategory] = key.split('-');
                        if (category === cats[i] && hasMatches) {
                            this.expandSubcategory(category, subcategory, true);
                        }
                    });
                }
                return true;
            },
            initTooltips() {
                this.$nextTick(() => {
                    try {
                        const tooltipTriggerList = this.$el.querySelectorAll('[data-bs-toggle="tooltip"]');
                        [...tooltipTriggerList].forEach(tooltipTriggerEl => {
                            try {
                                // Check if Bootstrap is available
                                if (!window.bootstrap || !window.bootstrap.Tooltip) {
                                    console.warn('Bootstrap Tooltip is not available');
                                    return;
                                }

                                // Dispose any existing tooltip
                                const existingTooltip = window.bootstrap.Tooltip.getInstance(tooltipTriggerEl);
                                if (existingTooltip) {
                                    existingTooltip.dispose();
                                }

                                // Only create new tooltip if element is valid
                                if (tooltipTriggerEl && tooltipTriggerEl.getAttribute('data-bs-original-title')) {
                                    new window.bootstrap.Tooltip(tooltipTriggerEl, {
                                        trigger: 'hover',
                                        html: true,
                                        container: 'body'
                                    });
                                }
                            } catch (tooltipError) {
                                console.warn('Error initializing tooltip:', tooltipError);
                            }
                        });
                    } catch (error) {
                        console.warn('Error in initTooltips:', error);
                    }
                });
            },
            isSubcategoryVisible(category, subcategory) {
                // On initial load, subcategory should only be visible if its parent category is expanded
                // If the category is not expanded, hide all its subcategories
                if (!this.expanded_categories.includes(category)) return false;
                // when the category is expanded, show all the subcategories
                return true;
            },
            getDisplayText(text) {
                if (!text) return '';
                
                // Try different possible separators
                const separators = [' › ', ' > ', ' - ', ': '];
                for (const separator of separators) {
                    if (text.includes(separator)) {
                        const parts = text.split(separator);
                        return parts.pop();
                    }
                }
                
                return text;
            },
        }
    }
</script>
